/**
 * Branding-Einstieg: laedt das Theme-CSS des aktiven Brands (Build-Zeit-Auswahl
 * via VITE_BRAND) und exportiert das branding-Objekt.
 *
 * `import.meta.env.VITE_BRAND` ist eine Build-Zeit-Konstante — Vite/Rollup
 * faltet die Bedingung und laesst nur EIN Theme im Bundle (kein Doppel-Import).
 */

import { branding } from "./branding"

if (import.meta.env.VITE_BRAND === "netzfabrik") {
  import("./themes/theme-netzfabrik.css")
} else {
  import("./themes/theme-rheinmetall.css")
}

// App-Titel zentral aus dem Branding (index.html haelt nur den statischen Fallback)
document.title = branding.appName

export { branding }
export type { Branding } from "./branding"
